// Generated by purs version 0.15.15
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Programs_Controllers_DocumentFinalEdits from "../Ouroboros.Programs.Controllers.DocumentFinalEdits/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
var readState = function (v) {
    return v;
};
var mkDocumentFinalEditsEnv = function (input) {
    return {
        loading: input.kernel.loading,
        navigate: input.kernel.navigate,
        reviewRoute: input.kernel.reviewRoute,
        document: input.kernel.document,
        activeSection: input.kernel.activeSection,
        finalEdits: input.kernel.finalEdits,
        updateSection: input.kernel.updateSection,
        replaceSection: input.kernel.replaceSection,
        taskRunner: input.kernel.taskRunner
    };
};
var buildDocumentFinalEditsViewProps = function (input) {
    var controller = Ouroboros_Programs_Controllers_DocumentFinalEdits.mkDocumentFinalEditsController(mkDocumentFinalEditsEnv(input));
    return {
        finalEdits: readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.finalEdits)),
        onFinalEditsChange: function (value) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(input.kernel.finalEdits))(value);
        },
        onSubmit: function (v) {
            return Ouroboros_Programs_Controllers_DocumentFinalEdits.runDocumentFinalEditsAction(controller.onSubmit);
        },
        onInit: Ouroboros_Services_Clients_Interop_Option.map(function (action) {
            return Ouroboros_Programs_Controllers_DocumentFinalEdits.runDocumentFinalEditsAction(action);
        })(controller.onInit)
    };
};
export {
    buildDocumentFinalEditsViewProps
};
//# sourceMappingURL=index.js.map
